/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

export interface KeyManagerRpcsAddEnclaveBody {
  name?: string;
}

export interface KeyManagerRpcsAddIdentityBody {
  enclave?: string;
  identity?: string;
  privilege?: string;
  isServiceAccount?: boolean;
}

export interface KeyManagerRpcsAddKeyBody {
  enclave?: string;
  name?: string;
  type?: string;
  addVersion?: boolean;
}

export interface KeyManagerRpcsAddKeyManagerBody {
  name?: string;
  namespace?: string;
  /** @format int32 */
  replicas?: number;
  expose?: boolean;
  volumeSize?: string;
  imageName?: string;
  storageClass?: string;
  volumeName?: string;
}

export interface KeyManagerRpcsAddPolicyBody {
  enclave?: string;
  name?: string;
  allow?: Record<string, MinioKMSRuleSet>;
  deny?: Record<string, MinioKMSRuleSet>;
}

export interface KeyManagerRpcsUpdateKeyManagerBody {
  /** @format int32 */
  replicas?: number;
  expose?: boolean;
  volumeSize?: string;
}

export interface GooglerpcStatus {
  /** @format int32 */
  code?: number;
  message?: string;
  details?: ProtobufAny[];
}

export type MinioEmpty = object;

export interface MinioEnclave {
  name?: string;
  /** @format int64 */
  createdAt?: string;
  createdBy?: string;
}

export interface MinioEnclaves {
  items?: MinioEnclave[];
  continueAt?: string;
}

export interface MinioKMSIdentities {
  items?: MinioKMSIdentity[];
  continueAt?: string;
}

export interface MinioKMSIdentity {
  name?: string;
  privilege?: string;
  policy?: string;
  /** @format int64 */
  createdAt?: string;
  createdBy?: string;
  isServiceAccount?: boolean;
  serviceAccounts?: string[];
}

export interface MinioKMSKey {
  name?: string;
  type?: string;
  version?: string;
  /** @format int64 */
  createdAt?: string;
  createdBy?: string;
}

export interface MinioKMSKeys {
  items?: MinioKMSKey[];
  continueAt?: string;
}

export interface MinioKMSPolicies {
  items?: MinioKMSPolicyStatus[];
  continueAt?: string;
}

export interface MinioKMSPolicyResponse {
  name?: string;
  allow?: Record<string, MinioKMSRuleSet>;
  deny?: Record<string, MinioKMSRuleSet>;
  /** @format int64 */
  createdAt?: string;
  createdBy?: string;
}

export interface MinioKMSPolicyStatus {
  name?: string;
  /** @format int64 */
  createdAt?: string;
  createdBy?: string;
}

export type MinioKMSRule = object;

export interface MinioKMSRuleSet {
  rules?: Record<string, MinioKMSRule>;
}

export interface MinioKeyManager {
  id?: string;
  name?: string;
  namespace?: string;
  /** @format int64 */
  sysCreated?: string;
}

export interface MinioKeyManagerDetails {
  id?: string;
  name?: string;
  namespace?: string;
  /** @format int32 */
  replicas?: number;
  expose?: boolean;
  volumeSize?: string;
  storageClass?: string;
}

export interface ProtobufAny {
  "@type"?: string;
  [key: string]: any;
}

export type QueryParamsType = Record<string | number, any>;
export type ResponseFormat = keyof Omit<Body, "body" | "bodyUsed">;

export interface FullRequestParams extends Omit<RequestInit, "body"> {
  /** set parameter to `true` for call `securityWorker` for this request */
  secure?: boolean;
  /** request path */
  path: string;
  /** content type of request body */
  type?: ContentType;
  /** query params */
  query?: QueryParamsType;
  /** format of response (i.e. response.json() -> format: "json") */
  format?: ResponseFormat;
  /** request body */
  body?: unknown;
  /** base url */
  baseUrl?: string;
  /** request cancellation token */
  cancelToken?: CancelToken;
}

export type RequestParams = Omit<
  FullRequestParams,
  "body" | "method" | "query" | "path"
>;

export interface ApiConfig<SecurityDataType = unknown> {
  baseUrl?: string;
  baseApiParams?: Omit<RequestParams, "baseUrl" | "cancelToken" | "signal">;
  securityWorker?: (
    securityData: SecurityDataType | null,
  ) => Promise<RequestParams | void> | RequestParams | void;
  customFetch?: typeof fetch;
}

export interface HttpResponse<D extends unknown, E extends unknown = unknown>
  extends Response {
  data: D;
  error: E;
}

type CancelToken = Symbol | string | number;

export enum ContentType {
  Json = "application/json",
  FormData = "multipart/form-data",
  UrlEncoded = "application/x-www-form-urlencoded",
  Text = "text/plain",
}

export class HttpClient<SecurityDataType = unknown> {
  public baseUrl: string = "";
  private securityData: SecurityDataType | null = null;
  private securityWorker?: ApiConfig<SecurityDataType>["securityWorker"];
  private abortControllers = new Map<CancelToken, AbortController>();
  private customFetch = (...fetchParams: Parameters<typeof fetch>) =>
    fetch(...fetchParams);

  private baseApiParams: RequestParams = {
    credentials: "same-origin",
    headers: {},
    redirect: "follow",
    referrerPolicy: "no-referrer",
  };

  constructor(apiConfig: ApiConfig<SecurityDataType> = {}) {
    Object.assign(this, apiConfig);
  }

  public setSecurityData = (data: SecurityDataType | null) => {
    this.securityData = data;
  };

  protected encodeQueryParam(key: string, value: any) {
    const encodedKey = encodeURIComponent(key);
    return `${encodedKey}=${encodeURIComponent(typeof value === "number" ? value : `${value}`)}`;
  }

  protected addQueryParam(query: QueryParamsType, key: string) {
    return this.encodeQueryParam(key, query[key]);
  }

  protected addArrayQueryParam(query: QueryParamsType, key: string) {
    const value = query[key];
    return value.map((v: any) => this.encodeQueryParam(key, v)).join("&");
  }

  protected toQueryString(rawQuery?: QueryParamsType): string {
    const query = rawQuery || {};
    const keys = Object.keys(query).filter(
      (key) => "undefined" !== typeof query[key],
    );
    return keys
      .map((key) =>
        Array.isArray(query[key])
          ? this.addArrayQueryParam(query, key)
          : this.addQueryParam(query, key),
      )
      .join("&");
  }

  protected addQueryParams(rawQuery?: QueryParamsType): string {
    const queryString = this.toQueryString(rawQuery);
    return queryString ? `?${queryString}` : "";
  }

  private contentFormatters: Record<ContentType, (input: any) => any> = {
    [ContentType.Json]: (input: any) =>
      input !== null && (typeof input === "object" || typeof input === "string")
        ? JSON.stringify(input)
        : input,
    [ContentType.Text]: (input: any) =>
      input !== null && typeof input !== "string"
        ? JSON.stringify(input)
        : input,
    [ContentType.FormData]: (input: any) =>
      Object.keys(input || {}).reduce((formData, key) => {
        const property = input[key];
        formData.append(
          key,
          property instanceof Blob
            ? property
            : typeof property === "object" && property !== null
              ? JSON.stringify(property)
              : `${property}`,
        );
        return formData;
      }, new FormData()),
    [ContentType.UrlEncoded]: (input: any) => this.toQueryString(input),
  };

  protected mergeRequestParams(
    params1: RequestParams,
    params2?: RequestParams,
  ): RequestParams {
    return {
      ...this.baseApiParams,
      ...params1,
      ...(params2 || {}),
      headers: {
        ...(this.baseApiParams.headers || {}),
        ...(params1.headers || {}),
        ...((params2 && params2.headers) || {}),
      },
    };
  }

  protected createAbortSignal = (
    cancelToken: CancelToken,
  ): AbortSignal | undefined => {
    if (this.abortControllers.has(cancelToken)) {
      const abortController = this.abortControllers.get(cancelToken);
      if (abortController) {
        return abortController.signal;
      }
      return void 0;
    }

    const abortController = new AbortController();
    this.abortControllers.set(cancelToken, abortController);
    return abortController.signal;
  };

  public abortRequest = (cancelToken: CancelToken) => {
    const abortController = this.abortControllers.get(cancelToken);

    if (abortController) {
      abortController.abort();
      this.abortControllers.delete(cancelToken);
    }
  };

  public request = async <T = any, E = any>({
    body,
    secure,
    path,
    type,
    query,
    format,
    baseUrl,
    cancelToken,
    ...params
  }: FullRequestParams): Promise<HttpResponse<T, E>> => {
    const secureParams =
      ((typeof secure === "boolean" ? secure : this.baseApiParams.secure) &&
        this.securityWorker &&
        (await this.securityWorker(this.securityData))) ||
      {};
    const requestParams = this.mergeRequestParams(params, secureParams);
    const queryString = query && this.toQueryString(query);
    const payloadFormatter = this.contentFormatters[type || ContentType.Json];
    const responseFormat = format || requestParams.format;

    return this.customFetch(
      `${baseUrl || this.baseUrl || ""}${path}${queryString ? `?${queryString}` : ""}`,
      {
        ...requestParams,
        headers: {
          ...(requestParams.headers || {}),
          ...(type && type !== ContentType.FormData
            ? { "Content-Type": type }
            : {}),
        },
        signal:
          (cancelToken
            ? this.createAbortSignal(cancelToken)
            : requestParams.signal) || null,
        body:
          typeof body === "undefined" || body === null
            ? null
            : payloadFormatter(body),
      },
    ).then(async (response) => {
      const r = response as HttpResponse<T, E>;
      r.data = null as unknown as T;
      r.error = null as unknown as E;

      const data = !responseFormat
        ? r
        : await response[responseFormat]()
            .then((data) => {
              if (r.ok) {
                r.data = data;
              } else {
                r.error = data;
              }
              return r;
            })
            .catch((e) => {
              r.error = e;
              return r;
            });

      if (cancelToken) {
        this.abortControllers.delete(cancelToken);
      }

      if (!response.ok) throw data;
      return data;
    });
  };
}

/**
 * @title keymanager.proto
 * @version version not set
 */
export class Api<
  SecurityDataType extends unknown,
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags KeyManagerRpcs
     * @name AddKeyManager
     * @request POST:/api/v2/sites/{siteID}/keymanagers
     */
    addKeyManager: (
      siteId: string,
      body: KeyManagerRpcsAddKeyManagerBody,
      params: RequestParams = {},
    ) =>
      this.request<MinioKeyManager, GooglerpcStatus>({
        path: `/api/v2/sites/${siteId}/keymanagers`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags KeyManagerRpcs
     * @name GetKeyManager
     * @request GET:/api/v2/sites/{siteID}/namespaces/{namespace}/keymanagers/{resourceID}
     */
    getKeyManager: (
      siteId: string,
      namespace: string,
      resourceId: string,
      params: RequestParams = {},
    ) =>
      this.request<MinioKeyManagerDetails, GooglerpcStatus>({
        path: `/api/v2/sites/${siteId}/namespaces/${namespace}/keymanagers/${resourceId}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags KeyManagerRpcs
     * @name DeleteKeyManager
     * @request DELETE:/api/v2/sites/{siteID}/namespaces/{namespace}/keymanagers/{resourceID}
     */
    deleteKeyManager: (
      siteId: string,
      namespace: string,
      resourceId: string,
      params: RequestParams = {},
    ) =>
      this.request<MinioEmpty, GooglerpcStatus>({
        path: `/api/v2/sites/${siteId}/namespaces/${namespace}/keymanagers/${resourceId}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags KeyManagerRpcs
     * @name UpdateKeyManager
     * @request PUT:/api/v2/sites/{siteID}/namespaces/{namespace}/keymanagers/{resourceID}
     */
    updateKeyManager: (
      siteId: string,
      namespace: string,
      resourceId: string,
      body: KeyManagerRpcsUpdateKeyManagerBody,
      params: RequestParams = {},
    ) =>
      this.request<MinioKeyManagerDetails, GooglerpcStatus>({
        path: `/api/v2/sites/${siteId}/namespaces/${namespace}/keymanagers/${resourceId}`,
        method: "PUT",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags KeyManagerRpcs
     * @name ListEnclaves
     * @request GET:/api/v2/sites/{siteID}/namespaces/{namespace}/keymanagers/{resourceID}/enclave
     */
    listEnclaves: (
      siteId: string,
      namespace: string,
      resourceId: string,
      query?: {
        prefix?: string;
        continueAt?: string;
        /** @format int64 */
        limit?: number;
        enclave?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MinioEnclaves, GooglerpcStatus>({
        path: `/api/v2/sites/${siteId}/namespaces/${namespace}/keymanagers/${resourceId}/enclave`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags KeyManagerRpcs
     * @name AddEnclave
     * @request POST:/api/v2/sites/{siteID}/namespaces/{namespace}/keymanagers/{resourceID}/enclave
     */
    addEnclave: (
      siteId: string,
      namespace: string,
      resourceId: string,
      body: KeyManagerRpcsAddEnclaveBody,
      params: RequestParams = {},
    ) =>
      this.request<MinioEmpty, GooglerpcStatus>({
        path: `/api/v2/sites/${siteId}/namespaces/${namespace}/keymanagers/${resourceId}/enclave`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags KeyManagerRpcs
     * @name DescribeEnclave
     * @request GET:/api/v2/sites/{siteID}/namespaces/{namespace}/keymanagers/{resourceID}/enclave/{enclave}
     */
    describeEnclave: (
      siteId: string,
      namespace: string,
      resourceId: string,
      enclave: string,
      params: RequestParams = {},
    ) =>
      this.request<MinioEnclave, GooglerpcStatus>({
        path: `/api/v2/sites/${siteId}/namespaces/${namespace}/keymanagers/${resourceId}/enclave/${enclave}`,
        method: "GET",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags KeyManagerRpcs
     * @name DeleteEnclave
     * @request DELETE:/api/v2/sites/{siteID}/namespaces/{namespace}/keymanagers/{resourceID}/enclave/{enclave}
     */
    deleteEnclave: (
      siteId: string,
      namespace: string,
      resourceId: string,
      enclave: string,
      params: RequestParams = {},
    ) =>
      this.request<MinioEmpty, GooglerpcStatus>({
        path: `/api/v2/sites/${siteId}/namespaces/${namespace}/keymanagers/${resourceId}/enclave/${enclave}`,
        method: "DELETE",
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags KeyManagerRpcs
     * @name ListIdentities
     * @request GET:/api/v2/sites/{siteID}/namespaces/{namespace}/keymanagers/{resourceID}/identities
     */
    listIdentities: (
      siteId: string,
      namespace: string,
      resourceId: string,
      query?: {
        prefix?: string;
        continueAt?: string;
        /** @format int64 */
        limit?: number;
        enclave?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MinioKMSIdentities, GooglerpcStatus>({
        path: `/api/v2/sites/${siteId}/namespaces/${namespace}/keymanagers/${resourceId}/identities`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags KeyManagerRpcs
     * @name AddIdentity
     * @request POST:/api/v2/sites/{siteID}/namespaces/{namespace}/keymanagers/{resourceID}/identities
     */
    addIdentity: (
      siteId: string,
      namespace: string,
      resourceId: string,
      body: KeyManagerRpcsAddIdentityBody,
      params: RequestParams = {},
    ) =>
      this.request<MinioEmpty, GooglerpcStatus>({
        path: `/api/v2/sites/${siteId}/namespaces/${namespace}/keymanagers/${resourceId}/identities`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags KeyManagerRpcs
     * @name DescribeIdentity
     * @request GET:/api/v2/sites/{siteID}/namespaces/{namespace}/keymanagers/{resourceID}/identities/{identity}
     */
    describeIdentity: (
      siteId: string,
      namespace: string,
      resourceId: string,
      identity: string,
      query?: {
        enclave?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MinioKMSIdentity, GooglerpcStatus>({
        path: `/api/v2/sites/${siteId}/namespaces/${namespace}/keymanagers/${resourceId}/identities/${identity}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags KeyManagerRpcs
     * @name DeleteIdentity
     * @request DELETE:/api/v2/sites/{siteID}/namespaces/{namespace}/keymanagers/{resourceID}/identities/{identity}
     */
    deleteIdentity: (
      siteId: string,
      namespace: string,
      resourceId: string,
      identity: string,
      query?: {
        enclave?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MinioEmpty, GooglerpcStatus>({
        path: `/api/v2/sites/${siteId}/namespaces/${namespace}/keymanagers/${resourceId}/identities/${identity}`,
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags KeyManagerRpcs
     * @name ListKeys
     * @request GET:/api/v2/sites/{siteID}/namespaces/{namespace}/keymanagers/{resourceID}/keys
     */
    listKeys: (
      siteId: string,
      namespace: string,
      resourceId: string,
      query?: {
        prefix?: string;
        continueAt?: string;
        /** @format int64 */
        limit?: number;
        enclave?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MinioKMSKeys, GooglerpcStatus>({
        path: `/api/v2/sites/${siteId}/namespaces/${namespace}/keymanagers/${resourceId}/keys`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags KeyManagerRpcs
     * @name AddKey
     * @request POST:/api/v2/sites/{siteID}/namespaces/{namespace}/keymanagers/{resourceID}/keys
     */
    addKey: (
      siteId: string,
      namespace: string,
      resourceId: string,
      body: KeyManagerRpcsAddKeyBody,
      params: RequestParams = {},
    ) =>
      this.request<MinioEmpty, GooglerpcStatus>({
        path: `/api/v2/sites/${siteId}/namespaces/${namespace}/keymanagers/${resourceId}/keys`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags KeyManagerRpcs
     * @name DescribeKey
     * @request GET:/api/v2/sites/{siteID}/namespaces/{namespace}/keymanagers/{resourceID}/keys/{key}
     */
    describeKey: (
      siteId: string,
      namespace: string,
      resourceId: string,
      key: string,
      query?: {
        enclave?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MinioKMSKey, GooglerpcStatus>({
        path: `/api/v2/sites/${siteId}/namespaces/${namespace}/keymanagers/${resourceId}/keys/${key}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags KeyManagerRpcs
     * @name DeleteKey
     * @request DELETE:/api/v2/sites/{siteID}/namespaces/{namespace}/keymanagers/{resourceID}/keys/{key}
     */
    deleteKey: (
      siteId: string,
      namespace: string,
      resourceId: string,
      key: string,
      query?: {
        enclave?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MinioEmpty, GooglerpcStatus>({
        path: `/api/v2/sites/${siteId}/namespaces/${namespace}/keymanagers/${resourceId}/keys/${key}`,
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags KeyManagerRpcs
     * @name ListPolicies
     * @request GET:/api/v2/sites/{siteID}/namespaces/{namespace}/keymanagers/{resourceID}/policies
     */
    listPolicies: (
      siteId: string,
      namespace: string,
      resourceId: string,
      query?: {
        prefix?: string;
        continueAt?: string;
        /** @format int64 */
        limit?: number;
        enclave?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MinioKMSPolicies, GooglerpcStatus>({
        path: `/api/v2/sites/${siteId}/namespaces/${namespace}/keymanagers/${resourceId}/policies`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags KeyManagerRpcs
     * @name AddPolicy
     * @request POST:/api/v2/sites/{siteID}/namespaces/{namespace}/keymanagers/{resourceID}/policies
     */
    addPolicy: (
      siteId: string,
      namespace: string,
      resourceId: string,
      body: KeyManagerRpcsAddPolicyBody,
      params: RequestParams = {},
    ) =>
      this.request<MinioEmpty, GooglerpcStatus>({
        path: `/api/v2/sites/${siteId}/namespaces/${namespace}/keymanagers/${resourceId}/policies`,
        method: "POST",
        body: body,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags KeyManagerRpcs
     * @name GetPolicy
     * @request GET:/api/v2/sites/{siteID}/namespaces/{namespace}/keymanagers/{resourceID}/policies/{policy}
     */
    getPolicy: (
      siteId: string,
      namespace: string,
      resourceId: string,
      policy: string,
      query?: {
        enclave?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MinioKMSPolicyResponse, GooglerpcStatus>({
        path: `/api/v2/sites/${siteId}/namespaces/${namespace}/keymanagers/${resourceId}/policies/${policy}`,
        method: "GET",
        query: query,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags KeyManagerRpcs
     * @name DeletePolicy
     * @request DELETE:/api/v2/sites/{siteID}/namespaces/{namespace}/keymanagers/{resourceID}/policies/{policy}
     */
    deletePolicy: (
      siteId: string,
      namespace: string,
      resourceId: string,
      policy: string,
      query?: {
        enclave?: string;
      },
      params: RequestParams = {},
    ) =>
      this.request<MinioEmpty, GooglerpcStatus>({
        path: `/api/v2/sites/${siteId}/namespaces/${namespace}/keymanagers/${resourceId}/policies/${policy}`,
        method: "DELETE",
        query: query,
        format: "json",
        ...params,
      }),
  };
}
